import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImagePreviewPopupComponent } from 'src/app/shared/image-preview-popup/image-preview-popup.component';
import { Context } from 'src/app/shared/models/context';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { Qualification } from 'src/app/shared/models/personnel';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { PersonalService } from 'src/app/shared/services/personal.service';

@Component({
  selector: 'app-qualification-approver',
  templateUrl: './qualification-approver.component.html',
  styleUrls: ['./qualification-approver.component.scss']
})
export class QualificationApproverComponent implements OnInit {
 public privilege: PrivilegeType;
  private context: Context;
  public isLoading: boolean = true;
  public qualifications: Qualification[] = [];
  public searchKeyword: string = "";
  private subscription: any;



  constructor(
    private commonService: CommonService,
    private modalService: NgbModal,
    private dataService: DataService,
    private authService: AuthService,
    private personnalService: PersonalService
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges('DELETE') });
    this.subscription = this.authService.getContext().subscribe(context => {
      if (context?.employeeId) {
        this.context = context;
        this.getQualifications();
      }
    });    
    this.getQualifications();
  }

  private getQualifications(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.qualifications = [];
      }
      this.personnalService.getQualifications(this.context.employeeId).subscribe({
        next: (qualifications: Qualification[]) => {
          this.qualifications = qualifications;
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    }
  }

  public upsertpopup(qualification: Qualification) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(ImagePreviewPopupComponent, { size: 'md', centered: true });
    modalRef.componentInstance.documentUrl = qualification.documentUrl;
    modalRef.componentInstance.type = 'Document File';
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
